import React from 'react';
import PrintPageLayout,{SignatureStamp,SignatureInput} from '../components/PrintPageLayout';
import {Box,Select,Date,Area,Button} from '../components/Input';
import {LoadGraphic} from '../components/Common';
import store from 'store';
import moment from 'moment';
import u from '../utilities/Utilities';
import "../styles/print-page-layout.scss";

export default class IncidentStatement extends React.Component{

    id = this.props.match.params.sid;

    r={};

    state={
        content:{},
        entryData:{},
        options:{},
        loading:false,
        loadText:"",
        permissions:{},
        changesMade:false,
    }

    componentDidMount=()=>{
        const content=store.get(this.id);
        this.getOptions();
        if(content){
            this.setState({
                    content:content,
                    entryData:this.onSetup(content),
                    permissions:u.getPermissions("incident"),
                });
        }
        else{
            window.location="/404";
        }
    }

    onSetup=(content)=>{
        let involved = Object.assign({},content.target);
        delete involved.statement;
        const statement=content.target.statement;
        let entryData={...involved,...statement};
        entryData.recordedOn = (entryData.bearerSign?.signOn) ? entryData.bearerSign.signOn : ((typeof entryData.recordedOn == "undefined") ? moment().format("YYYY-MM-DD HH:mm:ss") : entryData.recordedOn);
        entryData.recordedBy = (entryData.roSign?.signBy) ? entryData.roSign.signBy : ((typeof entryData.recordedBy == "undefined") ?  u.getFullName() : entryData.recordedBy);
        return entryData;
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:["gender"],
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                console.log(error);
            }
        });
    }
    
    onValidate=()=>{
        let keys=["name","nric","gender","contactNo","dob","employer"];
    }

    onClickSign=(field,name)=>{
        this.r['layout'].setPopupComponent(
            <SignatureInput onCancel={()=>{this.r['layout'].showPopup(false)}}
                            onComplete={(signatureStamp)=>{
                                this.onChange(signatureStamp,field);
                                this.r['layout'].showPopup(false);
                            }}
                            content={{
                                name:name
                            }}
                            />
        );
        this.r['layout'].showPopup(true);
    }

    onChange=(value,field,index)=>{
        let entryData=this.state.entryData;
        if(entryData[field] != value){
            //console.log(entryData[field],value);
            this.setState({changesMade:true})
        }
        entryData[field]=value;
        this.setState({entryData:entryData});
    }

    onUnsign=()=>{
        const onConfirm=async ()=>{
            this.setState({loading:true,loadText:"Updating..."});
            this.r['layout'].showPopup(false);

            try{
                const {content,entryData}=this.state;
                await u.postAsync({
                    url:"/api/incident-delete-statement-signatures",
                    data:{
                        incidentID:content.incidentID,
                        targetInvolved:content.target,
                    }
                });
                delete entryData.roSign;
                delete entryData.intepreterSign;
                delete entryData.bearerSign;
                this.setState({loading:false,entryData:entryData});
            }
            catch(e){
                const {error,status} = u.processError(e);
                console.log(error);
                this.setState({loading:false,error:error});
            }
        }

        this.r['layout'].setPopupComponent(
            <div className='default-popup'>
                <h2 className='text-negative'>Edit Signed Document?</h2>
                <div>
                    Note. All signatures will be deleted once you click confirm and the document will need to be signed again
                </div>
                <div style={{margin:"20px auto"}}>
                    <Button onClick={()=>{this.r['layout'].showPopup(false)}}>Cancel</Button>
                    <Button onClick={onConfirm}>Confirm</Button>
                </div>
            </div>
        );
        this.r['layout'].showPopup(true);
    }

    onSave=()=>{
        const {entryData,content} = this.state;
        this.setState({loading:true,loadText:"Saving..."});
        u.post({
            url:"/api/incident-save-statement",
            data:{
                incidentID:content.incidentID,
                targetInvolved:content.target,
                statement:entryData,
            },
            success:()=>{
                content.target.statement = entryData;
                store.set(this.id,content);
                this.setState({changesMade:false,loading:false});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    render=()=>{
        const {content,options,entryData,changesMade,permissions}=this.state;
        const hasPermLow = (permissions.create == 2 || permissions.update == 2);
        const hasPermHigh = (permissions.update == 2);
        const hasSign = (entryData.bearerSign?.sign);
        const canEdit = (!hasSign && hasPermLow);
        
        return (
            <PrintPageLayout ref={(ref)=>{this.r['layout']=ref}}
                             title={content.target?.involvementType + " Statement"}>
                
                <div className="print-page-container">
                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                    <img className="print-page-header-image" src="/images/app/app-logo.png"/>
                    <div className="print-page-title">{content.target?.involvementType} Statement</div>
                    <div className={'print-table-container' + ((!canEdit) ? " align-top": "")}>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='t-label'>Dormitory:</td>
                                    <td className='t-input'>{content.dormName}</td>
                                    <td className='t-divider'/>
                                    <td className='t-label'>Case No:</td>
                                    <td className='t-input'>{content.caseNumber}</td>
                                </tr>

                                <tr>
                                    <td>Recorded On:</td>
                                    <td>{moment(entryData.recordedOn).format("DD MMM YYYY - h:mma")}</td>
                                    <td className='t-divider'/>
                                    <td>Recorded By:</td>
                                    <td>{entryData.recordedBy}</td>
                                </tr>

                                <tr>
                                    <td>Name of {content.target?.involvementType}:</td>
                                    <td>
                                        {
                                            (canEdit)
                                                ?
                                                <Box ref={(ref)=>{this.r["name"]=ref}}
                                                     label="Name"
                                                     field="name"
                                                     values={{
                                                        value:entryData.name
                                                     }}
                                                     rules={{
                                                        required:true,
                                                     }}
                                                     onChange={this.onChange}
                                                     />
                                                :
                                                entryData.name
                                        }
                                        
                                    </td>
                                    <td className='t-divider'/>
                                    <td>NRIC/FIN:</td>
                                    <td>
                                    {
                                            (canEdit)
                                                ?
                                                <Box ref={(ref)=>{this.r["nric"]=ref}}
                                                     label="NRIC/FIN"
                                                     field="nric"
                                                     values={{
                                                        value:entryData.nric,
                                                        enabled:canEdit
                                                     }}
                                                     rules={{
                                                        required:true,
                                                     }}
                                                     onChange={this.onChange}
                                                     />
                                                :
                                                entryData.nric
                                    }
                                    </td>
                                </tr>

                                <tr>
                                    <td>Gender:</td>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Select ref={(ref)=>{this.r["gender"]=ref}}
                                                    label="Gender"
                                                    field="gender"
                                                    values={{
                                                        options:options.gender,
                                                        value:entryData.gender,
                                                        enabled:canEdit
                                                    }}
                                                    rules={{
                                                        required:true,
                                                    }}
                                                    onChange={this.onChange}
                                                    />
                                            :
                                            entryData.gender
                                    }
                                    </td>
                                    <td className='t-divider'/>
                                    <td>Contact No:</td>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Box ref={(ref)=>{this.r["contactNo"]=ref}}
                                                 label="Contact No"
                                                 field="contactNo"
                                                 values={{
                                                    value:entryData.contactNo,
                                                    enabled:canEdit
                                                 }}
                                                 rules={{
                                                    required:true,
                                                 }}
                                                 onChange={this.onChange}
                                                 />
                                            :
                                            entryData.contactNo
                                    }
                                    </td>
                                </tr>

                                <tr>
                                    <td>Date of Birth:</td>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Date ref={(ref)=>{this.r["dob"]=ref}}
                                                label="Date of Birth"
                                                field="dob"
                                                values={{
                                                    value:entryData.dob,
                                                    enabled:canEdit
                                                }}
                                                rules={{
                                                    required:true,
                                                }}
                                                range={[120,1]}
                                                onChange={this.onChange}
                                                />
                                            :
                                            moment(entryData.dob).format("DD MMM YYYY")
                                    }
                                    </td>
                                    <td className='t-divider'/>
                                    <td>Address:</td>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Box ref={(ref)=>{this.r["address"]=ref}}
                                                    label="Address"
                                                    field="address"
                                                    values={{
                                                        value:entryData.address,
                                                        enabled:canEdit
                                                    }}
                                                    rules={{
                                                        require:true,
                                                    }}
                                                    onChange={this.onChange}
                                                    />
                                            :
                                            entryData.address
                                    }
                                    </td>
                                </tr>

                                <tr>
                                    <td>Occupation:</td>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Box ref={(ref)=>{this.r["occupation"]=ref}}
                                                label="Occupation"
                                                field="occupation"
                                                values={{
                                                    value:entryData.occupation,
                                                    enabled:canEdit
                                                }}
                                                rules={{
                                                    required:true,
                                                }}
                                                onChange={this.onChange}
                                                />
                                            :
                                            entryData.occupation
                                    }
                                    </td>
                                    <td className='t-divider'/>
                                    <td>Employer:</td>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Box ref={(ref)=>{this.r["employer"]=ref}}
                                                    label="Employer"
                                                    field="employer"
                                                    values={{
                                                        value:entryData.employer,
                                                        enabled:canEdit
                                                    }}
                                                    rules={{
                                                        require:true,
                                                    }}
                                                    onChange={this.onChange}
                                                    />
                                            :
                                            entryData.employer
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={'print-table-oneline-container segmented-container' + ((!canEdit) ? " borders" : "")}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Statement of Incident:</td>
                                </tr>
                                <tr>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Area ref={(ref)=>{this.r["description"]=ref}}
                                                  label="Statement"
                                                  field="description"
                                                  values={{
                                                    value:entryData.description,
                                                    enabled:canEdit
                                                  }}
                                                  rules={{
                                                    required:true,
                                                    rows:15,
                                                  }}
                                                  onChange={this.onChange}
                                                  />
                                            :
                                            <div className="paragraphed-text">{entryData.description}</div>
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={'print-table-oneline-container segmented-container'}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>I affirm that I have given this statement has been given voluntarily without any threat, favour, promise and/or inducement, and I have read/explained over the statement and affirm it to be true and correct.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='print-table-container'>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='t-label'>Recording Officer:</td>
                                    <td className='t-input'>
                                        <SignatureStamp content={entryData.roSign}
                                                        onClick={()=>{this.onClickSign("roSign",u.getFullName())}}
                                                        enabled={hasPermLow}
                                                        />
                                    </td>
                                    <td className='t-divider'/>
                                    <td className='t-label'>Statement Bearer:</td>
                                    <td className='t-input'>
                                        <SignatureStamp content={entryData.bearerSign}
                                                        onClick={()=>{this.onClickSign("bearerSign",entryData.name)}}
                                                        enabled={hasPermLow}
                                                        />
                                    </td>
                                </tr>
                                <tr>
                                <td className='t-label'>Interpreter:</td>
                                    <td className='t-input'>
                                        <SignatureStamp content={entryData.intepreterSign}
                                                        onClick={()=>{this.onClickSign("intepreterSign","")}}
                                                        enabled={hasPermLow}
                                                        />
                                    </td>
                                    <td className='t-divider'/>
                                    <td className='t-label'/>
                                    <td className='t-input'/>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='print-page-hidden no-print'>
                        <div>Note. Statement will no longer be editable once the statement bearer signs the document</div>
                        <div className='page-error'>{this.state.error}</div>
                        <div>
                            {
                                (hasSign && hasPermLow)
                                    ?
                                    <Button onClick={this.onUnsign}>Edit Document</Button>
                                    :
                                    null
                            }
                            <Button enabled={(changesMade && hasPermLow)} onClick={this.onSave}>Save Changes</Button>
                        </div>
                    </div>
                </div>
            </PrintPageLayout>
        )
    }
}